import { ButtonGroup } from '@material-ui/core';
import cx from 'classnames';
import MuiButton from 'components/common/button/MuiButton';
import TeethContextMenu from 'components/common/teeth/clinic/TeethContextMenu';
import TeethSvgV2 from 'components/common/teeth/clinic/TeethSvgV2';
import { T } from 'components/common/text';
import { ITooth, IToothCopyData } from 'lib/types/clinic/projectTypes';
import React, { useEffect, useMemo, useRef } from 'react';
import { StoreSetter } from 'store/local/utils';
import styled from 'styled-components';

interface ProjectTeethProps {
  isViewer?: boolean;
  numbering?: number;
  setNumbering?: StoreSetter<number>;
  tooth?: ITooth | null;
  setTooth?: StoreSetter<ITooth | null>;
  onNumberingClick?: (numbering: number) => void;
  teeth?: ITooth[];
  setTeeth?: StoreSetter<ITooth[]>;
  bridge?: number[];
  setBridge?: StoreSetter<number[]>;
  copyData?: IToothCopyData;
  setCopyData?: StoreSetter<IToothCopyData>;
  teethContextActions?: {
    value: any;
    setValue: (f: (draft: any) => any) => void;
  };
  onToggleTooth?: (toothNumber: number) => void;
  onChangeToothValue?: (data: object | any) => void;
  onCopyTeeth?: (copyDataList: ITooth[]) => void;
}

const ProjectTeeth = ({
  isViewer = false,
  numbering,
  setNumbering,
  tooth,
  setTooth,
  teeth,
  setTeeth,
  bridge,
  setBridge,
  copyData,
  setCopyData,
  teethContextActions,
  onToggleTooth,
  onChangeToothValue,
  onNumberingClick,
  onCopyTeeth,
}: ProjectTeethProps) => {
  const toothSvgRef = useRef(null);

  return (
    <StyledProjectTeeth>
      {!isViewer && (
        <ButtonGroup className="projectTeeth__numbering_tab_box">
          <MuiButton
            className={cx('projectTeeth__numbering_tab sm', {
              active: numbering === 0,
            })}
            data-type="radio"
            // onClick={() => setNumbering(0)}
            onClick={() => !!onNumberingClick && onNumberingClick(0)}
          >
            <T>PROJECT_FDI</T>
          </MuiButton>
          <MuiButton
            className={cx('projectTeeth__numbering_tab sm', {
              active: numbering === 1,
            })}
            data-type="radio"
            // onClick={() => setNumbering(1)}
            onClick={() => !!onNumberingClick && onNumberingClick(1)}
          >
            <T>PROJECT_UNS</T>
          </MuiButton>
        </ButtonGroup>
      )}
      <div className="projectTeeth__teeth_box">
        {useMemo(() => {
          return (
            <div className={cx('projectTeeth__teeth_item')}>
              <input className="projectTeeth__teeth_focus_point" ref={toothSvgRef} />
              {isViewer ? (
                <TeethSvgV2
                  isEdit={false}
                  tooth={tooth}
                  numbering={{ value: numbering }}
                  teeth={{ value: teeth }}
                  bridge={{ value: bridge }}
                  onToggleTooth={(toothNumber: number) => {
                    onToggleTooth && onToggleTooth(toothNumber);
                  }}
                />
              ) : (
                <TeethContextMenu
                  component={
                    <TeethSvgV2
                      isEdit={true}
                      numbering={{ value: numbering, setValue: setNumbering }}
                      teeth={{ value: teeth, setValue: setTeeth }}
                      tooth={{ value: tooth, setValue: setTooth }}
                      bridge={{ value: bridge, setValue: setBridge }}
                      copyData={{ value: copyData, setValue: setCopyData }}
                      teethContextActions={teethContextActions}
                      onToggleTooth={(toothNumber: number) => {
                        onToggleTooth && onToggleTooth(toothNumber);
                      }}
                      onChangeToothValue={onChangeToothValue}
                      onCopy={onCopyTeeth}
                    />
                  }
                  numbering={{ value: numbering, setValue: setNumbering }}
                  teeth={{ value: teeth, setValue: setTeeth }}
                  tooth={{ value: tooth, setValue: setTooth }}
                  bridge={{ value: bridge, setValue: setBridge }}
                  copyData={{ value: copyData, setValue: setCopyData }}
                  teethContextActions={teethContextActions}
                  onChangeToothValue={onChangeToothValue}
                />
              )}
            </div>
          );
        }, [numbering, teeth, tooth, bridge, copyData, teethContextActions])}
      </div>
    </StyledProjectTeeth>
  );
};

const StyledProjectTeeth = styled.div`
  height: 100%;
  width: 100%;
  .projectTeeth__numbering_tab_box {
    position: relative;
    width: 100%;
    margin-bottom: 38px;
    .projectTeeth__numbering_tab {
      min-width: 50%;
    }
  }
  .projectTeeth__teeth_box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    .projectTeeth__teeth_item {
      max-width: 353px;
      width: 100%;
      .projectTeeth__teeth_focus_point {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        display: block;
        margin: 0;
        padding: 0;
        border: none;
      }
    }
  }
`;

export default ProjectTeeth;
